import React from 'react'
import ViewRealty from '@components/ViewRealty'
import { formatToLocale } from '@utils/numberFormatter'
import { formatValuationParamsString } from '@utils/formatValuationStrings'
import {
  Main,
  TopContent,
  RightContent,
  LeftContent,
  GoBack,
  Header,
  ContentWrapper,
  InnerContent,
  Text,
  ReportButton,
} from './styles'
import { FullArrowLeft } from '@icons'

const ValuationResult = ({
  goBack,
  evaluate,
  setSelectedRealties,
  selectedRealties,
  handleRecentOnlyClick,
  loadingAds,
  valuation = {},
  realties = [],
  filters = {},
}) => {
  const isValuation = valuation?.suggested_meter_price >= 0

  return (
    <Main>
      <TopContent>
        <LeftContent>
          <GoBack onClick={goBack}>
            <FullArrowLeft />
            Voltar à pesquisa
          </GoBack>
        </LeftContent>
        <RightContent>
          <Header>
            {isValuation ? 'Resultados da avaliação' : 'Seleção de Amostra'}
          </Header>
          <ContentWrapper>
            <InnerContent>
              <Text isLabel>Quartos</Text>
              <Text margin="18px">
                {formatValuationParamsString(valuation.bedrooms)}
              </Text>
              <Text isLabel>Suites</Text>
              <Text margin="18px">
                {formatValuationParamsString(valuation.suites)}
              </Text>
              <Text isLabel>Garagem</Text>
              <Text margin="18px">
                {formatValuationParamsString(valuation.garages)}
              </Text>
            </InnerContent>
            <InnerContent>
              <Text isLabel>Tipo de negócio</Text>
              <Text margin="18px">Venda</Text>
              <Text isLabel>Área</Text>
              <Text margin="18px">{valuation?.area}m²</Text>
            </InnerContent>

            {isValuation && (
              <InnerContent>
                <Text isLabel>Valor sugerido</Text>
                <Text margin="26px">
                  R$ {formatToLocale(valuation.suggested_price)}
                </Text>
                <Text isLabel>Valor do metro quadrado </Text>
                <Text margin="22px">
                  R$ {formatToLocale(valuation.suggested_meter_price)}
                </Text>
              </InnerContent>
            )}
            <InnerContent>
              <Text isLabel>Endereço</Text>
              <Text margin="26px">{`${valuation?.fullAddress}`}</Text>
              {(isValuation && (
                <ReportButton
                  onClick={() =>
                    window.open(
                      `/relatorio-avaliacao/${valuation?.id}`,
                      '_blank',
                    )
                  }
                >
                  Gerar relatório
                </ReportButton>
              )) || (
                <ReportButton onClick={evaluate}>Gerar avaliação</ReportButton>
              )}
            </InnerContent>
          </ContentWrapper>
        </RightContent>
      </TopContent>
      <ContentWrapper center>
        <ViewRealty
          loading={loadingAds}
          filters={filters}
          handleRecentOnlyClick={handleRecentOnlyClick}
          setSelectedRealties={setSelectedRealties}
          selectedRealties={selectedRealties}
          allowUpdate={!isValuation}
          selectable={!isValuation}
          realties={realties}
        />
      </ContentWrapper>
    </Main>
  )
}

export default ValuationResult
